import { movies } from '@/mocks/data';
import MovieCard from '@/components/feature/MovieCard';

export default function FeaturedMovies() {
  const featuredMovies = movies.filter((m) =>
    ['parasite', 'oldboy', 'burning', 'the-handmaiden', 'memories-of-murder', 'train-to-busan'].includes(m.id)
  );

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选推荐
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            我们为你精选的韩国电影佳作，每一部都值得反复品味
          </p>
        </div>
        <div
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5"
          data-product-shop
        >
          {featuredMovies.map((movie) => (
            <MovieCard key={movie.id} id={movie.id} />
          ))}
        </div>
      </div>
    </section>
  );
}